import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.phone) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    if (formData.message.length > 500) {
      alert('A mensagem não pode exceder 500 caracteres.');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('service', formData.service);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6et36eqd308q1a0ar50', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-32 bg-gradient-to-b from-white to-[#F8F6F4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 bg-[#915726]/10 rounded-full mb-6">
            <span className="text-[#915726] text-sm font-semibold tracking-wider uppercase">Entre em Contato</span>
          </div>
          <h2
            className="text-5xl md:text-6xl font-bold text-[#676028] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Agende Sua Avaliação
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Descubra como podemos ajudá-lo a alcançar seus objetivos
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100">
            <form id="contact-form" onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-3">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-5 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#915726] focus:border-transparent text-sm transition-all"
                  placeholder="Seu nome completo"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-3">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-5 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#915726] focus:border-transparent text-sm transition-all"
                  placeholder="seu@email.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-3">
                  Telefone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-5 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#915726] focus:border-transparent text-sm transition-all"
                  placeholder="(00) 00000-0000"
                />
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-semibold text-gray-700 mb-3">
                  Serviço de Interesse
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#915726] focus:border-transparent text-sm cursor-pointer transition-all"
                >
                  <option value="">Selecione um serviço</option>
                  <option value="emagrecimento">Emagrecimento Personalizado</option>
                  <option value="facial">Tratamentos Faciais</option>
                  <option value="corporal">Modelagem Corporal</option>
                  <option value="drenagem">Drenagem Linfática</option>
                  <option value="depilacao">Depilação a Laser</option>
                  <option value="capilar">Tratamentos Capilares</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-3">
                  Mensagem (máximo 500 caracteres)
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-5 py-4 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-[#915726] focus:border-transparent text-sm resize-none transition-all"
                  placeholder="Conte-nos um pouco sobre seus objetivos..."
                />
                <p className="text-xs text-gray-500 mt-2">
                  {formData.message.length}/500 caracteres
                </p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full px-8 py-5 bg-[#915726] text-white text-base font-semibold rounded-2xl hover:bg-[#7A3010] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {isSubmitting ? 'Enviando...' : 'Agendar Avaliação Gratuita'}
              </button>

              {submitStatus === 'success' && (
                <div className="p-5 bg-green-50 border border-green-200 rounded-2xl">
                  <p className="text-green-800 text-sm text-center font-medium">
                    Mensagem enviada com sucesso! Entraremos em contato em breve.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-5 bg-red-50 border border-red-200 rounded-2xl">
                  <p className="text-red-800 text-sm text-center font-medium">
                    Erro ao enviar mensagem. Por favor, tente novamente.
                  </p>
                </div>
              )}
            </form>
          </div>

          <div className="space-y-6">
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100">
              <h3
                className="text-3xl font-bold text-[#676028] mb-8"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Informações de Contato
              </h3>

              <div className="space-y-6">
                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#915726]/10 rounded-2xl flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-[#915726]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-base">Endereço</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      JFC Trade Center<br />
                      Av. Ministro Geraldo Barreto Sobral, 2100<br />
                      Jardins, Aracaju - SE, 49026-010<br />
                      Sala 201
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#915726]/10 rounded-2xl flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-[#915726]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-base">Telefone / WhatsApp</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      (79) 99982-7205
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#915726]/10 rounded-2xl flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-[#915726]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-base">E-mail</h4>
                    <p className="text-gray-600 text-sm">
                      plennitta@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-5">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#915726]/10 rounded-2xl flex-shrink-0">
                    <i className="ri-time-line text-2xl text-[#915726]"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-base">Horário de Atendimento</h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Segunda a Sexta: 8h às 20h<br />
                      Sábado: 9h às 14h
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100">
              <h3
                className="text-2xl font-bold text-[#676028] mb-6"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                Siga-nos nas Redes Sociais
              </h3>
              <div className="flex gap-4">
                <a
                  href="https://instagram.com/institutoplennitta"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-[#915726] text-white rounded-2xl hover:bg-[#7A3010] transition-all duration-300 cursor-pointer hover:scale-110"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://wa.me/5579999827205"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-14 h-14 flex items-center justify-center bg-[#915726] text-white rounded-2xl hover:bg-[#7A3010] transition-all duration-300 cursor-pointer hover:scale-110"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
                <a
                  href="mailto:plennitta@gmail.com"
                  className="w-14 h-14 flex items-center justify-center bg-[#915726] text-white rounded-2xl hover:bg-[#7A3010] transition-all duration-300 cursor-pointer hover:scale-110"
                >
                  <i className="ri-mail-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}